/**
 * LoggedByChip — compact attribution badge for section tables.
 *
 * Shows who logged an entry (name + optional role) as a small, unobtrusive
 * chip. Only rendered when loggedBy data is present on the document — old
 * entries without the field simply show nothing.
 *
 * Props:
 *   loggedBy  {{ name: string, role?: string, uid?: string }}
 */
export default function LoggedByChip({ loggedBy }) {
  if (!loggedBy?.name) return null;

  const initials = loggedBy.name
    .split(' ')
    .map((w) => w[0])
    .join('')
    .slice(0, 2)
    .toUpperCase();

  const label = loggedBy.role
    ? `${loggedBy.name} (${loggedBy.role.charAt(0).toUpperCase() + loggedBy.role.slice(1)})`
    : loggedBy.name;

  return (
    <span
      title={label}
      style={{
        display:        'inline-flex',
        alignItems:     'center',
        gap:            '0.25rem',
        fontSize:       '0.72rem',
        color:          'var(--text-light)',
        whiteSpace:     'nowrap',
      }}
    >
      <span style={{
        display:         'inline-flex',
        alignItems:      'center',
        justifyContent:  'center',
        width:           '18px',
        height:          '18px',
        borderRadius:    '50%',
        background:      'var(--primary-soft)',
        color:           'var(--primary-dark)',
        fontSize:        '0.6rem',
        fontWeight:      700,
        flexShrink:      0,
      }}>
        {initials}
      </span>
      {loggedBy.name}
    </span>
  );
}
